package cc.easyandroid.easycompose.component.router.children

import cc.easyandroid.easycompose.component.ComponentContextFactory
import cc.easyandroid.easycompose.component.backhandler.childBackHandler
import cc.easyandroid.easycompose.component.lifecycle.MergedLifecycle
import cc.easyandroid.easycompose.core.backhandler.BackHandler
import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeperDispatcher
import cc.easyandroid.easycompose.core.lifecycle.Lifecycle
import cc.easyandroid.easycompose.core.lifecycle.LifecycleRegistry
import cc.easyandroid.easycompose.core.statekeeper.SerializableContainer
import cc.easyandroid.easycompose.core.statekeeper.StateKeeperDispatcher

internal class DefaultChildItemFactory<out Ctx : Any, C : Any, out T : Any>(
    private val contextFactory: ComponentContextFactory<Ctx>,
    private val lifecycle: Lifecycle,
    private val backHandler: BackHandler,
    private val childFactory: (configuration: C, Ctx) -> T,
) : ChildItemFactory<C, T> {

    override fun invoke(
        configuration: C,
        key: String,
        savedState: SerializableContainer?,
        instanceKeeperDispatcher: InstanceKeeperDispatcher?
    ): ChildItem.Created<C, T> {
        val componentLifecycleRegistry = LifecycleRegistry()
        val mergedLifecycle = MergedLifecycle(lifecycle, componentLifecycleRegistry)
        val stateKeeperDispatcher = StateKeeperDispatcher(savedState)
        val instanceKeeperRegistry = instanceKeeperDispatcher ?: InstanceKeeperDispatcher()
        val backHandler = backHandler.childBackHandler()

        val component =
            childFactory(
                configuration,
                contextFactory(
                    lifecycle = mergedLifecycle,
                    stateKeeper = stateKeeperDispatcher,
                    instanceKeeper = instanceKeeperRegistry,
                    backHandler = backHandler,
                )
            )

        return ChildItem.Created(
            configuration = configuration,
            key = key,
            instance = component,
            lifecycleRegistry = componentLifecycleRegistry,
            stateKeeperDispatcher = stateKeeperDispatcher,
            instanceKeeperDispatcher = instanceKeeperRegistry,
            backHandler = backHandler,
        )
    }
}
